import { Translate } from "@phosphor-icons/react";
import "./PatientToggles.css";

/**
 * Toggle card for "this patient communicates in English".
 * Rendered inside a .ptg-grid by the create wizard and PatientProfilePage
 * edit mode when the clinic has englishCommunicationEnabled on.
 * Writes patient.communicationLanguage ("en" when on, "he" when off).
 */
export function EnglishCommunicationToggle({ language, onChange }) {
  const isOn = language === "en";

  return (
    <label className={`ptg-card ${isOn ? "is-on" : ""}`}>
      <span className="ptg-icon">
        <Translate size={17} weight={isOn ? "fill" : "duotone"} />
      </span>
      <span className="ptg-text">
        <span className="ptg-title">תקשורת באנגלית</span>
        <span className="ptg-sub">SMS ודף אישור הגעה יישלחו באנגלית</span>
      </span>
      <span className="ptg-switch">
        <input
          type="checkbox"
          checked={isOn}
          onChange={(e) => onChange(e.target.checked ? "en" : "he")}
        />
        <span className="ptg-slider"></span>
      </span>
    </label>
  );
}

export default EnglishCommunicationToggle;
